import type { QueryKey, UseInfiniteQueryOptions } from '@tanstack/react-query'
import { useInfiniteQueryWithAuth } from '@lib/Auth/clerk-utils'
import type { NeedsListPage } from './types'
import type { ClientError } from 'graphql-request'

export type UseNeedsInfiniteQueryOptions<
  TQueryFnData extends NeedsListPage,
  TError extends Error,
  TData,
  TQueryKey extends QueryKey,
> = UseInfiniteQueryOptions<
  TQueryFnData,
  TError,
  TData,
  TQueryFnData,
  TQueryKey
>

export function useNeedsInfiniteQuery<
  TQueryFnData extends NeedsListPage,
  TError extends Error = ClientError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseNeedsInfiniteQueryOptions<TQueryFnData, TError, TData, TQueryKey>
) {
  return useInfiniteQueryWithAuth<TQueryFnData, TError, TData, TQueryKey>({
    ...options,
    getNextPageParam(lastPage, _allPages) {
      if (typeof lastPage.needs_connection.pageInfo === 'undefined') {
        return undefined
      }

      if (lastPage.needs_connection.pageInfo.hasNextPage === false) {
        return undefined
      }

      return {
        after: lastPage.needs_connection.pageInfo.endCursor,
      }
    },
  })
}
